/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import { Button } from 'antd';
import Styled from 'styled-components';
import { FileAddFilled } from '@ant-design/icons'
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import Loading from "../../../../../components/Loading";
import Table from "../../../../../components/Table";
import PageHeader from "../../../../../components/Layout/PageHeader";

const mstp = ({ cadd, authentication, location }) => ({ cadd, authentication, location });

const Styles = Styled.div`
  .ant-page-header {
    padding: 8px 8px 8px var(--size);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .ant-page-header-heading {
			justify-content: flex-start;
    }
    .ant-page-header-heading-extra {
			display: flex;
			margin-left: var(--size);
		}
    .ant-btn {
      display: flex;
      span[role="img"] {
        font-size: 18px;
      }
    }
  }
  .ant-space {
    width: 100%;
    .ant-space-item {
      width: 100%;
    }
  }
  .ant-btn {
    display: flex;
    span[role="img"] {
      margin: auto;
    }
  }
  .ant-input-affix-wrapper-disabled  {
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    input {
      background-color: transparent;
      cursor: text;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .columns {
    span[role="img"] {
      margin-left: 8px
    }
  }
  .projectLink {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    text-decoration: underline;
  }
  .ant-drawer-body {
    padding: 0;
  }
`


const getHeaderColumns = (t) => [
  {
    title: t('ID'),
    dataIndex: 'aisId',
    key: 'aisId',
    show: true,
    sorter: (a, b) => ('' + a.aisId).localeCompare(b.aisId),
    render: aisId => (
      <NavLink className="projectLink" to={`/app/cadd/shipment/${aisId}`}>
        {aisId}
      </NavLink>
    ),
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => ('' + a.name).localeCompare(b.name),
    key: 'name',
    show: true,
  },
  {
    title: t('Country'),
    dataIndex: 'country',
    key: 'country',
    show: true,
  },
]

function Shipments({
  authentication: { user },
}) {
  const { t } = useTranslation();
  const HeaderColumns = getHeaderColumns(t);
  const data = true;

  return !data ? <Loading /> : (
    <Styles>
      <PageHeader
        title={t("Shipments")}
        extra={[<Button
          type="link"
          key="1"
          disabled={true}
          icon={<FileAddFilled />}
          onClick={() => { }}>
          {t("New").toUpperCase()}
        </Button>]} />
      <div className="column start" style={{ padding: '0 18px' }}>
        <Table style={{ marginTop: '12px' }} columns={HeaderColumns} data={[]} size="small" rowKey="projectId" />
      </div>
    </Styles>
  );
}


export default connect(mstp)(Shipments);
